/* ========================================
   LOGO 3D DRAG GUARD
   The header/site logo is a <model-viewer camera-controls> wrapped in an
   <a href="/"> (click logo = go home). Without this, dragging to ROTATE the
   3D logo ends in a mouseup that the anchor reads as a click → it navigates
   home mid-drag. This suppresses the anchor click when the pointer was
   dragged (rotation), while a real quick click/tap still goes home.
   Header lives outside #MainContent so it survives soft-nav; we still re-bind
   on sync:page-loaded for safety (idempotent via __logoBound).
   ======================================== */
(function () {
  var MOVE_THRESHOLD = 6; // px of travel before we treat it as a drag, not a click

  function bind() {
    var anchors = document.querySelectorAll('a.site-logo');
    for (var i = 0; i < anchors.length; i++) {
      (function (a) {
        var mv = a.querySelector('model-viewer');
        if (!mv || a.__logoBound) return;
        a.__logoBound = true;

        var startX = 0, startY = 0, dragged = false;

        mv.addEventListener('pointerdown', function (e) {
          startX = e.clientX; startY = e.clientY; dragged = false;
        });
        mv.addEventListener('pointermove', function (e) {
          if (Math.abs(e.clientX - startX) > MOVE_THRESHOLD ||
              Math.abs(e.clientY - startY) > MOVE_THRESHOLD) {
            dragged = true;
          }
        });

        // Capture phase so we intercept before the browser follows the link.
        a.addEventListener('click', function (e) {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
          }
        }, true);
      })(anchors[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('sync:page-loaded', bind);
})();
